import React, {useEffect, useState} from "react";
import MainLayout from "../MainLoyout/MainLayout";
import {
    Autocomplete, Badge,
    Box, Card, CardActions, CardContent, Checkbox,
    Chip, CircularProgress,
    Container, Drawer,
    FormControl, FormControlLabel, Grid,
    InputLabel,
    Paper,
    Select, Stack, Table, TableBody, TableCell, TableContainer, TableRow,
    tooltipClasses
} from "@mui/material";
import Api from "../../Services/Api";
import {DataGrid, GridActionsCellItem, GridToolbar} from "@mui/x-data-grid";
import Skeleton from "@mui/material/Skeleton";
import Title from "../Title";
import Typography from "@mui/material/Typography";
import {useSelector} from "react-redux";
import TextField from "@mui/material/TextField";
import Success from "../Snackbar/Success";

import {
    AccountBalance, Balance, CheckCircle,
    ContentCopy,
    Download, EventNote,
    InfoOutlined, Money, MoneyRounded, MoneySharp,
    Payment,
    PhotoCamera,
    Receipt,
    UploadFile,
    Visibility
} from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import BillingInfoForm from "../Users/BillingInfoForm";
import PaymentMethodForm from "../Users/PaymentInfoForm";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import {Alert} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";


const Invoices = () => {


    const [rowStatuses, setRowStatuses] = useState({});

    const [invoice, setInvoice] = React.useState([]);
    const [invoices, setInvoices] = React.useState([]);
    const [uploading, setUploading] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [pageSize, setPageSize] = React.useState(100);
    const [editMessage, setEditMessage] = React.useState(null);
    const user = useSelector((state) => state.users)
    const [downloadDate, setDownloadDate] = useState(dayjs().subtract(2, 'month'));

    const [openBillingInfo, setOpenBillingInfo] = React.useState(false);
    const [openPaymentMethod, setOpenPaymentMethod] = React.useState(false);

    const [open, setOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [confirmChecked, setConfirmChecked] = useState(false);
    const [nextPaymentAmount, setNextPaymentAmount] = useState(null);
    const [nextPaymentCycle, setNextPaymentCycle] = useState(null);
    const [paidBalance, setPaidBalance] = useState(null);
    const [outstandingBalance, setOutstandingBalance] = useState(null);

    const handleClickOpen = (row) => {
        setSelectedId(row);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCheckboxChange = (event) => {
        setConfirmChecked(event.target.checked);
    };




    useEffect(() => {

        loadInvoices()



    }, []);

    const loadInvoices = () => {
        setLoading(true)
        Api.invoices().then(r => {
            setInvoices(r.invoices)
            setLoading(false)
            setNextPaymentCycle(r.next_payment_date ?? null)
            setNextPaymentAmount(r.next_payment_amount ?? null)
            setOutstandingBalance(r.outstanding_balance ?? null)
            setPaidBalance(r.paid_balance ?? null)



        })
    }

    const LoadingSkeleton = () => (
        <Box
            sx={{
                height: "max-content"
            }}
        >
            {[...Array(20)].map((item, key) => (
                <Skeleton key={key} variant="rectangular" sx={{my: 2, mx: 1}}/>
            ))}
        </Box>
    );



    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const handleShow = (id, type) => {

        Api.invoice(id).then(r => {
            setInvoice(r)
            if(type == "billing"){
                setOpenBillingInfo(true)
            }
            else
            {
                setOpenPaymentMethod(true)
            }
        })
    }

    const formatNumber = (value) => {
        if (isNaN(value) || value === null) return 0
        const valueFormatted = parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        return `${valueFormatted}`;
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        return `${year}-${month}`;
    };




    const columns = [
        {
            field: "id",
            headerName: "Invoice ID",
            type: 'number',
            editable: false,
            flex: 0.1,
            minWidth: 40,

        },

        {
            field: "formatted_month",
            headerName: "Month",
            type: 'string',
            editable: false,
            flex: 0.1,
            minWidth: 50,

        },
        {
            field: "account_id",
            headerName: "Account ID",
            type: 'string',
            editable: false,
            flex: 0.1,
            minWidth: 50,
            valueGetter: (params) => params.row?.user_id

        },

        {
            field: "account_name",
            headerName: "Account",
            type: 'string',
            editable: false,
            flex: 0.2,
            minWidth: 150,
            valueGetter: (params) => params.row?.user?.name

        },

        {
            field: "billed_revenue",
            headerName: "Billed Revenue",
            type: 'number',
            editable: false,
            flex: 0.2,
            minWidth: 150,
            valueGetter: (params) => params.row.gross_revenue + params.row.adjusted_revenue,
            valueFormatter: (params) => {
                const valueFormatted = formatNumber(params.value)
                return "$" + valueFormatted;
            },
            renderCell: (params) => {
                const valueFormatted = formatNumber(params.value)
                const adjustedRev = parseFloat(params.row.adjusted_revenue)
                return <Box display="flex"
                            alignItems="center"><span>{"$" + valueFormatted}</span> {adjustedRev > 0 && <Tooltip
                    title={adjustedRev >= 0 ? "Adjusted Revenue: " + params.row.gross_revenue + "+" + params.row.adjusted_revenue : "Adjusted Revenue: " + params.row.gross_revenue + params.row.adjusted_revenue}>
                    <InfoOutlined fontSize={"small"} sx={{ml: 1}} color={"warning"}/></Tooltip>}</Box>;
            }
        },

        {
            field: "payment_due_date",
            headerName: "Due Date",
            type: 'string',
            editable: false,
            flex: 0.2,
            minWidth: 50

        },
        {
            field: "status",
            headerName: "Status",
            flex: 0.4,
            minWidth: 150,
            valueGetter: (params) => {

                return params.row?.status?.name

            },
            renderCell: (params) => {

                if (params.row?.status?.slug == 'pending') {
                    return <Chip label={params.row?.status?.name} color="warning" size="small" />;
                } else if (params.row?.status?.slug == 'billing_missing') {
                    return (
                        <Chip
                            label={params.row?.status?.name}
                            sx={{ backgroundColor: '#ff1744', color: 'white' }} // Apply custom styles for the 'ready' status
                            size="small"
                        />
                    );

                } else if (params.row?.status?.slug == 'rejected') {
                    return <Chip label={params.row?.status?.name} color="error" size="small" />;
                } else if (params.row?.status?.slug == 'paid') {
                    return <Chip label={params.row?.status?.name} color="success" size="small" />;
                } else if (params.row?.status?.slug == 'ready') {
                    return (
                        <Chip
                            label={params.row?.status?.name+' 👌'}
                            sx={{ backgroundColor: '#8bc34a', color: 'white' }} // Apply custom styles for the 'ready' status
                            size="small"
                        />
                    );
                } else {
                    return <Chip label={params.row?.status?.name} color="info" size="small" />;
                }
            }
        },

        {
            headerName: "Actions",
            field: 'Actions',
            type: 'actions',
            flex: 0.4,
            minwidth: 250,
            getActions: (params) => (!params.row?.uploaded ? [
                <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                    disabled={params.row?.status.slug != "confirmed"}
                    onClick={() => handleClickOpen(params.row)}
                >
                    {uploading != params.row?.id ? (
                        <UploadFile />
                    ) : (
                        <CircularProgress color="primary" size={24} />
                    )}
                </IconButton>
            ] : [
                <IconButton color="primary" aria-label="upload picture" component="label" onClick={() => handleDownload(params.row?.id, params.row?.month)}>
                    <Download  />
                </IconButton>,
                <IconButton color="primary" aria-label="upload picture" component="label" onClick={() => handleClickOpen(params.row)}>
                    {uploading != params.row?.id ? (
                        <UploadFile  />
                    ) : (
                        <CircularProgress color="primary" size={24} />
                    )}
                </IconButton>,
                <IconButton color={new Date(params.row?.billing?.created_at) >= beginningOfMonth ? "warning" : "primary"} aria-label="show billing and payment info" component="label" onClick={() => handleShow(params.row?.id, "billing")}>
                    <AccountBalance  />
                </IconButton>,
                <IconButton color={new Date(params.row?.payment_method?.created_at) >= beginningOfMonth ? "warning" : "primary"} aria-label="show billing and payment info" component="label" onClick={() => handleShow(params.row?.id, "payment")}>
                    <Payment  />
                </IconButton>,
                user.is_admin ? <IconButton color={params.row.status.slug == "paid" || rowStatuses[params.row?.id] === 'success' ? "success":"primary"}   onClick={() => markInvoiceAsPaid(params.row?.id)}  >
                    <CheckCircle />
                </IconButton>:<IconButton />,
                user.is_admin ? <IconButton color={params.row.status.slug == "xp" || rowStatuses[params.row?.id] === 'success' ? "success":"primary"}   onClick={() => markInvoiceAsXP(params.row?.id)}  >
                    <Balance />
                </IconButton>:<IconButton />

            ])
        }

    ]

    const markInvoiceAsPaid = (id) => {

        Api.invoiceMarkAsPaid({id: id}).then(r => {

            setRowStatuses({
                ...rowStatuses,
                [id]: r.success ? 'success' : 'error'
            });


        })
    }

    const markInvoiceAsXP = (id) => {

        Api.invoiceMarkAsXP({id: id}).then(r => {

            setRowStatuses({
                ...rowStatuses,
                [id]: r.success ? 'success' : 'error'
            });


        })
    }


    const beginningOfMonth = new Date();
    beginningOfMonth.setDate(1);
    beginningOfMonth.setHours(0, 0, 0, 0);


    const handleUpload = (event) => {

        console.log(selectedId)
        setUploading(selectedId.id)
        setOpen(false)
        Api.uploadInvoice({file: event.target.files[0], id: selectedId.id}).then(r => {
            setUploading(false)
            setEditMessage(r)
            loadInvoices()
        })
    }

    const handleDownload = (id, month) => {


        Api.downloadInvoice({invoiceId: id}).then(r => {

            if(!r)
            {
                setEditMessage({message: 'Error: contact your account manager for more info'})
                return
            }
            console.log(r)
            const file = new Blob([r.data], {type: 'application/pdf'});
            const fileUrl = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = 'typ_' + id + '_' + month + '.pdf';
            link.click();
        }).catch( error => {

        })

    }


    const onCellEditCommit = (params, event) => {
        Api.updateInvoice(params).then(r => {

                setEditMessage(r)
            }
        )
    }


    const handleDownloadClick = () => {
        // Format the date with day as 01 always
        const formattedDate = dayjs(downloadDate).format('YYYY-MM') + '-01';

        Api.downloadBulkInvoices({month: formattedDate}).then(response => {
            console.log(response);

            // Create a URL from the Blob data
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a hidden anchor element
            const link = document.createElement('a');
            link.href = url;
            const formattedDate = downloadDate.format('YYYY_MM');
            const timestamp = dayjs().format('YYYYMMDD_HHmmss');
            const fileName = `invoices_${formattedDate}_${timestamp}.csv`;
            link.setAttribute('download', fileName); // Name of the downloaded file
            document.body.appendChild(link);

            // Programmatically click the anchor element to initiate the download
            link.click();

            // Clean up by removing the anchor element and revoking the Blob URL
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            console.log("Download initiated for date: " + formattedDate);
        });
    };


    const disableLastTwoMonths = (date) => {
        const oneMonthAgo = dayjs().subtract(2, 'month');
        return date.isAfter(oneMonthAgo.startOf('month'), 'month');
    };


    return (

        <MainLayout>
            <Success successMessage={editMessage} setSuccessMessage={setEditMessage}>
                {editMessage?.message}
            </Success>

            <Drawer
                anchor={"right"}
                open={openBillingInfo || openPaymentMethod}
                onClose={() => {
                    setOpenBillingInfo(false);
                    setOpenPaymentMethod(false);
                } }
            >
                {openBillingInfo && <BillingInfoForm form={invoice?.billing} setForm={setInvoice} setDrawer={setOpenBillingInfo} setReload={false} />}
                {openPaymentMethod && <PaymentMethodForm form={invoice?.payment_method} setForm={setInvoice} setDrawer={setOpenPaymentMethod} setReload={false} />}

            </Drawer>


            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>

                <Grid container spacing={3} sx={{mb: 3}}>
                    <Grid item xs={12} sm={3}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" component="div" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    Next Payment Cycle
                                    <Tooltip title={
                                        <>
                                            <Typography variant="body2" color="white" fontWeight="bold">
                                                Next Payment Cycle
                                            </Typography>
                                            <br />

                                            <Typography variant="body2">
                                                Payments are routinely processed on the 15th of each month. However, please note that there might be delays due to demand confirmation and pending receipts from the demand side.
                                            </Typography>
                                            <br />
                                            <Typography variant="body2" color="white" fontWeight="bold">
                                                Remember to upload your invoices timely to avoid payment delays.
                                            </Typography>
                                                <br />
                                                <Typography variant="body2">
                                                If the total accumulated amount does not meet the threshold limit, the payment will be deferred to the next cycle. Keeping your billing information up-to-date ensures smooth transactions each cycle.
                                            </Typography>
                                        </>
                                    } arrow>
                                        <IconButton size="small">
                                            <InfoOutlined fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Typography>
                                <Typography variant="h5">
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <EventNote sx={{ mr: 1 }} />
                                        {nextPaymentCycle ? dayjs(nextPaymentCycle).format('MMMM D, YYYY') : 'No Data'}
                                    </Box>
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" component="div" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    Upcoming Payment Amount
                                    <Tooltip title={
                                        <>
                                            <Typography variant="body2" color="white" fontWeight="bold">
                                                Upcoming Payment Amount
                                            </Typography>
                                            <br />

                                            <Typography variant="body2">
                                                This figure represents the cumulative amount to be paid in the next billing cycle, factoring in all invoices uploaded in our system up until the payment cycle date.
                                            </Typography>
                                        </>
                                    }  arrow>
                                        <IconButton size="small">
                                            <InfoOutlined fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Typography>
                                <Typography variant="h5">
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <MoneySharp sx={{ mr: 1 }} />
                                        {nextPaymentAmount !== null ? '$'+formatNumber(nextPaymentAmount) : 'No Data'}
                                    </Box>
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" component="div" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    Total Outstanding
                                    <Tooltip title={
                                        <>
                                            <Typography variant="body2" color="white" fontWeight="bold">
                                                Total Outstanding
                                            </Typography>
                                            <br />

                                            <Typography variant="body2">
                                                Total Outstanding represents the cumulative amount generated by the publisher from all invoices that are yet to be paid. It showcases the total revenue earned from generated invoices that are still pending payment. This gives an insight into the total amount owed to the publisher, highlighting the earnings that have been recognized but not yet settled.
                                            </Typography>
                                        </>
                                    }  arrow>
                                        <IconButton size="small">
                                            <InfoOutlined fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Typography>
                                <Typography variant="h5">
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <MoneySharp sx={{ mr: 1 }} />
                                        {outstandingBalance !== null ? '$'+formatNumber(outstandingBalance) : 'No Data'}
                                    </Box>
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" component="div" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    Total Paid
                                    <Tooltip title={
                                        <>
                                            <Typography variant="body2" color="white" fontWeight="bold">
                                                Total Paid
                                            </Typography>
                                            <br />

                                            <Typography variant="body2">
                                                Total Paid Invoices represent the aggregate amount that has been settled and paid to the publisher.
                                            </Typography>
                                        </>
                                    }  arrow>
                                        <IconButton size="small">
                                            <InfoOutlined fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Typography>
                                <Typography variant="h5">
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <MoneySharp sx={{ mr: 1 }} />
                                        {paidBalance !== null ? '$'+formatNumber(paidBalance) : 'No Data'}
                                    </Box>
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                {user.is_admin &&
                <Paper sx={{mb: 2, p: 2}}>
                <FormControl sx={{minWidth: 200}} size={"small"}>
                    <Stack direction="row" spacing={2} sx={{pb: 2}}>
                        Download Invoices for Super Admins Only
                    </Stack>
                    <Stack direction="row" spacing={2}>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            views={['year', 'month']}
                            label="Year and Month"
                            minDate={dayjs('2022-05-01')}
                            maxDate={dayjs('2026-01-01')}
                            value={downloadDate}
                            size={"small"}
                            onChange={(newValue) => {
                                setDownloadDate(newValue);



                            }}
                            renderInput={(params) => <TextField {...params} helperText={null} />}
                            shouldDisableDate={disableLastTwoMonths}

                        />
                    </LocalizationProvider>
                    <Button variant="contained" onClick={handleDownloadClick} startIcon={<Download />}>
                        download
                    </Button>
                    </Stack>
                </FormControl>

                </Paper>}


                <Paper sx={{p: 2, display: 'flex', flexDirection: 'column'}}>
                    <Title>Invoices</Title>
                    <Typography variant="body2" gutterBottom>
                        Numbers are confirmed normally before Net15. For more information ask your account manager.
                    </Typography>

                    <DataGrid
                        rows={!loading ? invoices : []}
                        columns={columns}
                        pageSize={pageSize}
                        onCellEditCommit={onCellEditCommit}

                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        autoHeight={true}
                        disableSelectionOnClick
                        hideFooter={false}
                        hideFooterPagination={false}
                        disableColumnSelector


                        sx={{
                            mt: 2,
                            mb: 2,
                        }}
                        density={"compact"}
                        components={{
                            LoadingOverlay: LoadingSkeleton,
                            Toolbar: GridToolbar,

                        }}
                        componentsProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: {debounceMs: 500},
                            },
                        }}
                        loading={loading}
                    />


                </Paper>
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle>Confirm Payment and Billing Information</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Please confirm that the payment and billing information are correct before uploading the invoice.
                        </DialogContentText>

                        <Box sx={{mt: 2}} />

                        <Alert severity="warning">
                            Please note that the following data will be the one used to transfer you the funds regardless of the data included in the invoice. If the data is not correct, you can add a new one on the <a href={"/billing"}>billing settings.</a>
                        </Alert>
                        <Box sx={{mt: 2}} />
                        <Typography variant="h6">Billing Information</Typography>
                        <TableContainer>
                            <Table>
                                <TableBody>

                                    {selectedId?.billing?.company ?
                                    <TableRow>
                                        <TableCell>Company Name</TableCell>
                                        <TableCell>{selectedId?.billing?.company_name}</TableCell>
                                    </TableRow>:
                                        <>
                                            <TableRow>
                                                <TableCell>First Name</TableCell>
                                                <TableCell>{selectedId?.billing?.first_name}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Last Name</TableCell>
                                                <TableCell>{selectedId?.billing?.last_name}</TableCell>
                                            </TableRow>
                                        </>}
                                    <TableRow>
                                        <TableCell>Tax ID</TableCell>
                                        <TableCell>{selectedId?.billing?.tax_id}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Address</TableCell>
                                        <TableCell>{selectedId?.billing?.address}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Country</TableCell>
                                        <TableCell>{selectedId?.billing?.country}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>State</TableCell>
                                        <TableCell>{selectedId?.billing?.state}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>City</TableCell>
                                        <TableCell>{selectedId?.billing?.city}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Postal Code</TableCell>
                                        <TableCell>{selectedId?.billing?.postal_code}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box sx={{mt: 2}} />
                        <Typography variant="h6">Payment Method</Typography>
                        <TableContainer>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Bank Name</TableCell>
                                        <TableCell>{selectedId?.payment_method?.bank_name}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Address</TableCell>
                                        <TableCell>{selectedId?.payment_method?.address}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Country</TableCell>
                                        <TableCell>{selectedId?.payment_method?.country}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>State</TableCell>
                                        <TableCell>{selectedId?.payment_method?.state}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>City</TableCell>
                                        <TableCell>{selectedId?.payment_method?.city}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Account Number</TableCell>
                                        <TableCell>{selectedId?.payment_method?.account_number}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>IBAN</TableCell>
                                        <TableCell>{selectedId?.payment_method?.iban}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>SWIFT</TableCell>
                                        <TableCell>{selectedId?.payment_method?.swift}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Currency</TableCell>
                                        <TableCell>{selectedId?.payment_method?.currency.toUpperCase()}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Notes</TableCell>
                                        <TableCell>{selectedId?.payment_method?.notes}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box sx={{mt: 2}} />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={confirmChecked}
                                    onChange={handleCheckboxChange}
                                    name="confirmInfo"
                                />
                            }
                            label="I confirm that the payment and billing information are correct."
                        />
                        <Box sx={{mt: 2}} />

                        <input
                            hidden
                            accept="application/pdf"
                            type="file"
                            id={'upload-' + selectedId}
                            onChange={(event) => handleUpload(event)}
                        />
                        <label htmlFor={'upload-' + selectedId}>
                            <Button variant="contained" color="primary" component="span" disabled={!confirmChecked}>
                                Upload Invoice
                            </Button>
                        </label>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                    </DialogActions>
                </Dialog>


            </Container>
        </MainLayout>
    )
}


export default Invoices